import React from 'react';
import HighlightsCard from '../HighlightsCard';
import { useTileData } from '../../../hooks/useTileData';
import { getRecoveryStats } from '../../../api';
import { fmtCurrency } from '../../shared/format';

// 2026-08-13 — this tile shows RECOVERED revenue (from the email recovery
// system), not booking revenue. Was calling getBookingKpis and deriving
// revenue from total_bookings × avg_booking_value, which showed the wrong
// number ($10,708 booking revenue instead of $204.80 recovered revenue on
// Verde 30d). Now calls getRecoveryStats and reads revenue_recovered directly.
// Verified via probe: 30d = $204.80 (1 conversion), 7d = $0 (0 conversions).
const revenueFrom = (data) => {
  if (!data) return 0;
  return Number(data.revenue_recovered ?? 0);
};

const captionFor = (delta) => {
  if (delta == null || !Number.isFinite(delta)) return 'This period';
  if (delta > 20) return 'Strong period';
  if (delta > 5) return 'Trending up';
  if (delta > -5) return 'Steady vs last';
  return 'Down vs last period';
};

export default function RevenueHighlight({ clientId, rangeStart, rangeEnd }) {
  const { data, loading, error } = useTileData(
    async () => {
      const resp = await getRecoveryStats(clientId, rangeStart, rangeEnd);
      return resp?.data ?? null;
    },
    [clientId, rangeStart, rangeEnd],
    Boolean(clientId && rangeStart && rangeEnd),
  );

  const revenue = revenueFrom(data);
  const delta = null; // recovery stats don't return a previous period; skip delta
  // TODO: if we want a delta, call getRecoveryStats twice (current + previous
  // period) or ask backend to add a previous-period block to fn_get_recovery_stats.

  return (
    <HighlightsCard
      label="Recovered Revenue"
      value={fmtCurrency(revenue)}
      delta={delta}
      caption={captionFor(delta)}
      loading={loading}
      error={error}
    />
  );
}

